export default {
    fields: [
        {
            key: "id",
            label:"#",
            sorter: false,
            filter: false,
            _style: "width:5%",
        },
        {
            key: "lead_id",
            label:"lead_id",
            sorter: false,
            filter: true,
            _style: "width:10%",
        },
        {
            key: "request",
            label:"request",
            sorter: false,
            filter: true,
            _style: "width:20%",
        },
        {
            key: "response",
            label:"response",
            sorter: false,
            filter: true,
            _style: "width:20%",
        },
        {
            key: "status",
            label:"status",
            sorter: false,
            filter: true,
            _style: "width:10%",
        },
        
        
    ],
    items: [],
    order: "desc",
    orderField: "id",
    rows: 10,
    page: 1,
    total_pages: 0,
    loading: true,
    pagination: false,
    sorter: true,
    responsive: true,
    columnFilter: {
        external: true,
        lazy: true
    },
    allFields:[],
    columnFilterValue: {},
    itemsPerPageSelect: true,
}